/**
 * Footer Menu Accessibility (jQuery Version with Window Resize Handling)
 */

document.addEventListener('DOMContentLoaded', function () {
    jQuery(function ($) {
        const $footerColumns = $('.m-menu__column');
        let previousIsMobile = window.innerWidth <= 1024;
        let isFirstRun = true;

        function setupFooterMenu() {
            const isMobile = window.innerWidth <= 1024;

            if (!isFirstRun && isMobile === previousIsMobile) return;
            previousIsMobile = isMobile;
            isFirstRun = false;

            if (!isMobile) {
                // Desktop: Ensure menus are always visible & remove interactions
                $('.m-menu__column nav').removeClass('sr-only').removeAttr('aria-hidden');
                $('.a-title').off('click keydown').removeAttr('role aria-expanded aria-controls tabindex');
                return;
            }

            // Mobile: Apply dropdown behavior
            $footerColumns.each(function (index) {
                const $column = $(this);
                const $title = $column.find('.a-title');
                const $menu = $column.find('nav');

                if (!$title.length || !$menu.length) return;

                $menu.attr('id', $menu.attr('id') || `footer-menu-${index}`).addClass('sr-only');
                $title.attr({
                    role: 'button',
                    'aria-expanded': 'false',
                    'aria-controls': $menu.attr('id'),
                    tabindex: 0
                });

                // Inject SVG icon if not already added
                if (!$title.find('.footer-icon-wrapper').length) {
                    $title.append(`
                        <span class="footer-icon-wrapper">
                            <svg class="footer-toggle-icon w-full" width="19" viewBox="0 0 19 10" aria-hidden="true">
                                <use xlink:href="#icon-chevron-down"></use>
                            </svg>
                        </span>
                    `);
                }

                function toggleMenu() {
                    const isExpanded = $title.attr('aria-expanded') === 'true';
                    $title.attr('aria-expanded', !isExpanded);
                    $menu.toggleClass('sr-only', isExpanded);
                    $title.find('svg').toggleClass('rotate-180', !isExpanded);
                    updateTabIndex($menu, isExpanded);
                }

                function handleKeydown(event) {
                    if (['Enter', ' '].includes(event.key)) {
                        event.preventDefault();
                        toggleMenu();
                    }

                    if (event.key === 'Tab' && $title.attr('aria-expanded') === 'false') {
                        const $nextTitle = event.shiftKey
                            ? $footerColumns.eq(index - 1).find('.a-title')
                            : $footerColumns.eq(index + 1).find('.a-title');

                        if ($nextTitle.length) {
                            event.preventDefault();
                            $nextTitle.focus();
                        }
                    }
                }

                // Prevent duplicate event bindings
                $title.off('click keydown').on('click', toggleMenu).on('keydown', handleKeydown);
            });
        }

        function updateTabIndex($menu, disable) {
            $menu.find('a, button, input, select, textarea').attr('tabindex', disable ? '-1' : '0');
        }

        // Run on page load and window resize
        setupFooterMenu();
        $(window).on('resize', setupFooterMenu);
    });
});